<template>
  <div class="navigation-settings">
    <v-col class="mt-4 pt-0">
      <div class="mt-2">
        <p class="text-color-text">
          Use canals
        </p>
      </div>
      <ThemedCheckbox
        v-model="useSuezModel"
        label="Suez"
        class="ma-0 pa-0"
        :ripple="false"
        dense
        :input-value="useSuezModel"
      />
      <ThemedCheckbox
        v-model="usePanamaModel"
        label="Panama"
        :ripple="false"
        class="mt-1 pa-0"
        dense
        :input-value="usePanamaModel"
      />
      <ThemedCheckbox
        v-model="useKielModel"
        label="Kiel"
        class="mt-1 pa-0"
        :ripple="false"
        dense
        :input-value="useKielModel"
      />
      <ThemedCheckbox
        v-model="useTaiwanStraitModel"
        label="Taiwan Strait"
        :ripple="false"
        class="mt-1 pa-0"
        dense
        :input-value="useTaiwanStraitModel"
      />
      <div class="mt-2">
        <p class="text-color-text">
          Special zones
        </p>
      </div>
      <ThemedCheckbox
        v-model="tssModel"
        label="Traffic Separation Schemes"
        class="ma-0 pa-0"
        :ripple="false"
        dense
        :input-value="tssModel"
      />
      <ThemedCheckbox
        v-model="ecaModel"
        label="Emission Control Areas"
        :ripple="false"
        class="mt-1 pa-0"
        dense
        :input-value="ecaModel"
      />
      <ThemedCheckbox
        v-model="avoidPiracyModel"
        label="Avoid piracy zones"
        class="mt-1 pa-0"
        :ripple="false"
        dense
        :input-value="avoidPiracyModel"
      />
      <ThemedCheckbox
        v-model="avoidTropicalStormsModel"
        label="Avoid tropical storms"
        class="mt-1 pa-0"
        :ripple="false"
        dense
        :input-value="avoidTropicalStormsModel"
      />
      <div class="mt-2">
        <p class="text-color-text">
          Land Proximity (nmi)
        </p>
      </div>
      <ThemedTextField
        v-model="landProximityModel"
        outlined
        persistent-placeholder
        class="mr-15"
        type="number"
      />
    </v-col>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ThemedCheckbox from "@/core/ThemedCheckbox.vue";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "NavigationSettings",
  components: {
    ThemedCheckbox,
    ThemedTextField,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/formModule", [
      "landProximity",
      "tss",
      "eca",
      "avoidPiracy",
      "avoidTropicalStorms",
      "useSuez",
      "useKiel",
      "usePanama",
      "useTaiwanStrait",
    ]),
    landProximityModel: {
      get() {
        return this.landProximity;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_LAND_PROXIMITY",
          value,
          { root: true }
        );
      },
    },
    tssModel: {
      get() {
        return this.tss;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_TSS", value, {
          root: true,
        });
      },
    },
    ecaModel: {
      get() {
        return this.eca;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_ECA", value, {
          root: true,
        });
      },
    },
    avoidPiracyModel: {
      get() {
        return this.avoidPiracy;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_AVOID_PIRACY",
          value,
          {
            root: true,
          }
        );
      },
    },
    avoidTropicalStormsModel: {
      get() {
        return this.avoidTropicalStorms;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_AVOID_TROPICAL_STORMS",
          value,
          {
            root: true,
          }
        );
      },
    },
    useSuezModel: {
      get() {
        return this.useSuez;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_USE_SUEZ", value, {
          root: true,
        });
      },
    },
    useKielModel: {
      get() {
        return this.useKiel;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_USE_KIEL", value, {
          root: true,
        });
      },
    },
    usePanamaModel: {
      get() {
        return this.usePanama;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_USE_PANAMA", value, {
          root: true,
        });
      },
    },
    useTaiwanStraitModel: {
      get() {
        return this.useTaiwanStrait;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_USE_TAIWAN_STRAIT",
          value,
          {
            root: true,
          }
        );
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.navigation-settings {
  background-color: var(--color-surface);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.text-color-text {
  color: var(--color-text);
}
</style>
